var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'd-flex',
    'flex-column',
    'align-stretch',
    _vm.alignBottom ? 'align-bottom' : '' ]},_vm._l((_vm.labels),function(label,i){return _c('GridMargin',{key:i,attrs:{"height":_vm.boxHeight,"data-y-index":i}},[_c('span',{staticClass:"text-caption grey--text text--darken-1 pl-2"},[_vm._v(" "+_vm._s(label)+" ")])])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }